import React from "react";
import "./pools.css";

const PoolHeader = () => {
  return (
    <div className="pool-header-container search-pool-head">
      Your Liquidity Pools
    </div>
  );
};

export default PoolHeader;
